import React, { useEffect, useState } from 'react';
import { Button, Form, Tabs,notification} from 'antd';
import { useLocation, useHistory } from 'react-router-dom';
import axios from 'axios';
import _ from 'underscore';
import setting from '../../config/setting';
import TestDetailOfEmployee from './Test_Detail_of_Employee/TestDetailOfEmployee';
const config = require('../keyFront');
const { TabPane } = Tabs;
let navTabCheck;
const EmployeeDetail = ({ patient }) => {
  let IdtypeCheckValue = JSON.parse(localStorage.getItem('IdtypeCheckValue'));
  navTabCheck = JSON.parse(localStorage.getItem('NavTabCheck'));

  const renderField = (fieldName, label, patient) => (
    <p key={fieldName}>
      <span style={{ width: '49.5%', display: 'inline-block' }}>{label} :</span>{' '}
      <span style={{ width: '30%', display: 'inline-block' }}>
        {patient && patient[fieldName] ? patient[fieldName] : ''}
      </span>
    </p>
  );

  const renderFieldsBasedOnIdType = (IdtypeCheckValue, patient) => {
    return IdtypeCheckValue.map((idType) => {
    let fieldKey = "";
    let label = "";

    switch (idType) {
      case "SSN":
        fieldKey = "emp_ssn";
        label = "Employee SSN";
        break;
      case "EIN":
        fieldKey = "emp_ein";
        label = "Employee EIN";
        break;
      case "DL":
        fieldKey = "DL";
        label = "Employee DL";
        break;
      default:
        return null;
    }

    return (
      <div key={idType} style={{flex: "1 1 33%",maxWidth: "33.33%",marginBottom: 12}}>
        <span style={{ opacity: 0.8 }}>{label}</span>
        <br />
        <span style={{ fontWeight: "bold" }}>
          {patient?.[fieldKey] || ""}
        </span>
      </div>
    );
  });
  };

  const renderedFields = renderFieldsBasedOnIdType(IdtypeCheckValue, patient);
  return (
    <Form layout="vertical" style={{ marginTop: 20 }}>
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',gap:'20px'}}>
    {/* PERSONAL INFORMATION CARD */}
    <div
      className="col-md-6 col-sm-12"
      style={{
        height:"300px",
        background: "linear-gradient(135deg, #3a7bd5, #3a6073)",
        borderRadius: "10px",
        padding: "20px",
        color: "#fff",
        boxShadow: "0px 3px 8px rgba(0,0,0,0.2)",
      }}
    >
      <h6 style={{ color: "#fff", fontWeight: "bold", marginBottom: 20 }}>
        PERSONAL INFORMATION
      </h6>

      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <div style={{ flex: "1 1 33%",maxWidth: "33.33%", marginBottom: 12 }}>
          <span style={{ opacity: 0.8 }}>Employee Name</span>
          <br />
          <span style={{ fontWeight: "bold" }}>
            {patient?.first_name || ""} {patient?.last_name || ""}
          </span>
        </div>

        <div style={{ flex: "1 1 33%",maxWidth: "33.33%", marginBottom: 12 }}>
          <span style={{ opacity: 0.8 }}>DOB</span>
          <br />
          <span style={{ fontWeight: "bold" }}>{patient?.dob || ""}</span>
        </div>

        <div style={{ flex: "1 1 33%", marginBottom: 12 }}>
          <span style={{ opacity: 0.8 }}>Sex </span>
          <br />
          <span style={{ fontWeight: "bold" }}>{patient?.Gender || ""}</span>
        </div>

        <div style={{ flex: "1 1 33%",maxWidth: "33.33%", marginBottom: 12 }}>
          <span style={{ opacity: 0.8 }}>Mobile Number </span>
          <br />
          <span style={{ fontWeight: "bold" }}>{patient?.Mobile || ""}</span>
        </div>

        <div style={{ flex: "1 1 33%",maxWidth: "33.33%", marginBottom: 12 }}>
          <span style={{ opacity: 0.8 }}>Alternate Phone</span>
          <br />
          <span style={{ fontWeight: "bold" }}>
            {patient?.Alternate_Phones && patient.Alternate_Phones !== "NaN"
              ? patient.Alternate_Phones
              : ""}
          </span>
        </div>
      </div>
    </div>

    {/* EMPLOYER INFORMATION CARD */}
    <div
      className="col-md-6 col-sm-12"
      style={{
        height:"300px",
        background: "linear-gradient(135deg, #3a7bd5, #3a6073)",
        borderRadius: "10px",
        padding: "20px",
        color: "#fff",
        boxShadow: "0px 3px 8px rgba(0,0,0,0.2)",
      }}
    >
      <h6 style={{ color: "#fff", fontWeight: "bold", marginBottom: 20 }}>
        EMPLOYER INFORMATION
      </h6>

      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <div style={{ flex: "1 1 33%",maxWidth: "33.33%", marginBottom: 12 }}>
          <span style={{ opacity: 0.8 }}>Status</span>
          <br />
          <span style={{ fontWeight: "bold" }}>
            {patient?.emp_status
              ? patient.emp_status.charAt(0).toUpperCase() +
                patient.emp_status.slice(1)
              : ""}
          </span>
        </div>
        {renderedFields}
        <div style={{ flex: "1 1 33%",maxWidth: "33.33%", marginBottom: 12 }}>
          <span style={{ opacity: 0.8 }}>Location</span>
          <br />
          <span style={{ fontWeight: "bold" }}>
            {patient?.emp_location || ""}
          </span>
        </div>

        <div style={{ flex: "1 1 33%",maxWidth: "33.33%", marginBottom: 12 }}>
          <span style={{ opacity: 0.8 }}>Supervisor</span>
          <br />
          <span style={{ fontWeight: "bold" }}>
            {patient?.newSupervisor || ""}
          </span>
        </div>

        <div style={{ flex: "1 1 33%",maxWidth: "33.33%", marginBottom: 12 }}>
          <span style={{ opacity: 0.8 }}>Email</span>
          <br />
          <span style={{ fontWeight: "bold" }}>{patient?.email || ""}</span>
        </div>

        <div style={{ flex: "1 1 33%",maxWidth: "33.33%", marginBottom: 12 }}>
          <span style={{ opacity: 0.8 }}>Job Title</span>
          <br />
          <span style={{ fontWeight: "bold" }}>{patient?.jobTitle || ""}</span>
        </div>

        <div style={{ flex: "1 1 33%",maxWidth: "33.33%", marginBottom: 12 }}>
          <span style={{ opacity: 0.8 }}>Department</span>
          <br />
          <span style={{ fontWeight: "bold" }}>{patient?.newDept || ""}</span>
        </div>

        <div style={{ flex: "1 1 33%",maxWidth: "33.33%", marginBottom: 12 }}>
          <span style={{ opacity: 0.8 }}>Hire/Rehire Date</span>
          <br />
          <span style={{ fontWeight: "bold" }}>
            {patient?.hireRehireDate || ""}
          </span>
        </div>

        <div style={{ flex: "1 1 33%",maxWidth: "33.33%", marginBottom: 12 }}>
          <span style={{ opacity: 0.8 }}>Termination Date</span>
          <br />
          <span style={{ fontWeight: "bold" }}>
            {patient?.terminationDate || ""}
          </span>
        </div>
      </div>
    </div>
  </div>
    </Form>
  );
};
const PatientProfilePage = () => {
  const [empName, setEmployeeFirstName] = useState('');
  const [imageUrls, setImageUrls] = useState([]);
  const [imageUrl, setImageUrl] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [CovidVaccinationData, setCovidVaccinationData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [companyName, setCompanyName] = useState([]);
  const [attachmentData, setAttachmentData] = useState([]);
  const [CovidTestData, setCovidTestData] = useState([]);
  const [CovidReportData, setCovidReportData] = useState([]);

  const [attachmentChange, setAttachmentChange] = useState(false);
  const [change1, setChange1] = useState(false);
  const [change, setChange] = useState(false);
  const location = useLocation();
  const data = location.state;
  const [covidVaccinationChange, setCovidVaccinationChange] = useState(true);
  const [covidTestChange, setCovidTestChange] = useState(true);
  const [isCovReportLoading, setIsCovReportLoading] = useState(false);

  const [covidReportChange, setCovidReportChange] = useState(true);
  const [docVaccPermission, setdocVaccPermission] = useState(false);
  const [docTestPermission, setdocTestPermission] = useState(false);
  const [hasAttachmentPermission, setHasAttachmentPermission] = useState(false);
  const [hasVaccPermission, setHasVaccPermission] = useState(false);
  const [hasCovTestPermission, setHasCovTestPermission] = useState(false);
  const [hasCovReportPermission, setHasCovReportPermission] = useState(false);
  const [isVaccLoading, setIsVaccLoading] = useState(false);
  const [isCovTestLoading, setIsCovTestLoading] = useState(false);
  const [errVaccMsg, setErrVaccMsg] = useState('');
  const [covTestErrMsg, setCovTestErrMsg] = useState('');
  const [covReportErrMsg, setCovReportErrMsg] = useState('');

  let history = useHistory();

    const handleSessionExpired = () => {
  notification.open({
    message: 'Odoo session expired',
    description: 'Please login again.',
  });

  localStorage.clear();
  history.push('/public/sign-in');
};
  useEffect(() => {
    if (data != undefined) {
      setEmployeeFirstName(data['display_name']);
      // if (navTabCheck && navTabCheck[0].covid_vac) {
      //   getVaccination();
      //   getVaccDocPermission();
      // }
      if (navTabCheck && navTabCheck[0].covid_test) {
        getTestData(data);
        getTestDocPermission();
      }
      getAttachment();
      getAttachmentPermission();
    } else {
      history.goBack();
    }
  }, []);

  useEffect(() => {
    createTable();
  }, [CovidVaccinationData]);

  const getAttachmentPermission = () => {
    axios
      .post(setting.serverUrl + '/api/documentPermission', {
        params: {
          user: localStorage.getItem('myData'),
          // pass: localStorage.getItem('myPass'),
          docId: config.menuPermission.CovidVaccinationDocs
        }
      },{
        withCredentials:true
      })
      .then((response) => {
        if (response.status === 200) {
          setHasAttachmentPermission(true);
        }
      }).catch((error) => {
      // ✅ Handle session expired
      if (error?.response?.status === 401) {
        handleSessionExpired();
        return;
      }
    });
  };

  const getVaccDocPermission = () => {
    axios
      .post(setting.serverUrl + '/api/documentPermission', {
        params: {
          user: localStorage.getItem('myData'),
          pass: localStorage.getItem('myPass'),
          docId: config.menuPermission.CovidVaccinationDocs
        }
      })
      .then((response) => {
        if (response.status === 200) {
          setdocVaccPermission(true);
        }
      });
  };
  
  const getTestDocPermission = () => {
    axios
      .post(setting.serverUrl + '/api/documentPermission', {
        params: {
          user: localStorage.getItem('myData'),
          // pass: localStorage.getItem('myPass'),
          docId: config.menuPermission.TestDetailDocs
        }
      },{
        withCredentials:true
      })
      .then((response) => {
        if (response.status === 200) {
          setdocTestPermission(true);
        }
      }).catch((error) => {
      // ✅ Handle session expired
      if (error?.response?.status === 401) {
        handleSessionExpired();
        return;
      }
    });
  };

  const getAttachment = () => {
    setAttachmentChange(true);
    axios
      .post(setting.serverUrl + '/api/getEmployeeAttachmentCustomer', {
        params: {
          email: localStorage.getItem('myData'),
          user: localStorage.getItem('myData'),
          // pass: localStorage.getItem('myPass'),
          employeeId: data['id']
        }
      },{
        withCredentials:true
      })
      .then((response) => {
        if (response && response.data.error) {
          alert('Some Technical Error Occurred!');
        }

        if (response && response.status === 200) {
          if (response.data.length === 0) {
            setAttachmentChange(true);
          } else {
            setAttachmentChange(false);
          }
          setAttachmentData(response.data);
          setAttachmentChange(false);
        }
      }).catch((error) => {
      // ✅ Handle session expired
      if (error?.response?.status === 401) {
        handleSessionExpired();
        return;
      }
    });
  };

  function getTestData(data) {
    setIsCovTestLoading(true);
    setCovidTestChange(true);
    axios
      .post(setting.serverUrl + '/api/Covid_test_CustomerPortal', {
        params: {
          email: localStorage.getItem('myData'),
          user: localStorage.getItem('myData'),
          // pass: localStorage.getItem('myPass'),
          customerId: localStorage.getItem('customerId'),
          compId: JSON.parse(localStorage.getItem('customerData')).id,
          empId: data.id
        }
      },{
        withCredentials:true
      })
      .then((response) => {
        setIsCovTestLoading(false);
        if (response && response.data.error) {
          alert('Some Technical Error Occurred!');
        }
        if (response && response.status == 200) {
          let employeeTests = response && response.data;
          console.log('employee list covid test===========', employeeTests);
          setHasCovTestPermission(true);
          setCompanyName(response.data.length > 0 && response.data[0].display_name);
          setCovidTestData(employeeTests);
          setCovidTestChange(false);
        } else if (response.status === 201) {
          setCovTestErrMsg('Access permission not allowed.');
        }
      }).catch((error) => {
      // ✅ Handle session expired
      if (error?.response?.status === 401) {
        handleSessionExpired();
        return;
      }
    });
  }

  function download2(e, attachment_url) {
    setChange1(change1);
    axios
      .post(setting.serverUrl + '/api/downloadTestingCertificate', {
        params: {
          email: localStorage.getItem('myData'),
          user: localStorage.getItem('myData'),
          pass: localStorage.getItem('myPass'),
          attachment_url: attachment_url
        }
      })
      .then((response) => {
        if (response && response.data.error) {
          alert('Some Technical Error Occurred!');
        }
        setChange1(!change1);
        window.open(response.data);
      });
  }

  const handleCancel = () => {
    setIsModalVisible(false);
    setImageUrls([]);
  };

  const createTable = () => {
    let table = [];

    if (CovidVaccinationData.length > 0) {
      CovidVaccinationData.map((data) => {
        let d = table.filter((t) => t.id === data.employee[0]);

        if (d.length === 0) {
          let employeeData = {
            id: data.employee[0],
            name: data.employee[1],
            status: data.testing_status,
            conducted_by: data.conducted_by,
            attachment_url: data.attachment_url,
            attachment_id: data.attachment_id,
            vaccination: [],
            no_of_vaccination: 0
          };

          let vaccine = {
            vacData:
              data.test_date && data.test_type ? data.test_date + ' - ' + data.test_type : '',
            attachment_url: data.attachment_url,
            attachment_id: data.attachment_id
          };
          employeeData.vaccination.push(vaccine);
          employeeData.no_of_vaccination += 1;
          table.push(employeeData);
        } else {
          table.map((t) => {
            if (t.id === data.employee[0]) {
              let vaccine = {
                vacData:
                  data.test_date && data.test_type ? data.test_date + ' - ' + data.test_type : '',
                attachment_url: data.attachment_url,
                attachment_id: data.attachment_id
              };
              t.vaccination.push(vaccine);
              t.attachment_url = data.attachment_url ? data.attachment_url : t.attachment_url;
              t.attachment_id = data.attachment_id ? data.attachment_id : t.attachment_id;
              t.no_of_vaccination += 1;
            }
          });
        }
      });
      console.log('table in covid vaccination', table);
      setTableData(table);
    }
  };

  const getVaccination = () => {
    setCovidVaccinationChange(true);
    setIsVaccLoading(true);
    axios
      .post(setting.serverUrl + '/api/Covid_Vaccination_customerportal', {
        params: {
          email: localStorage.getItem('myData'),
          user: localStorage.getItem('myData'),
          pass: localStorage.getItem('myPass'),
          customerId: localStorage.getItem('customerId'),
          employeeId: data['id']
        }
      })
      .then((response) => {
        setIsVaccLoading(false);
        if (response && response.status == 200 && response.data.length == 0) {
          setHasVaccPermission(true);
          setCovidVaccinationChange(false);
        } else if (
          response &&
          response.status === 200 &&
          response.data &&
          response.data.length > 0
        ) {
          setHasVaccPermission(true);
          let vaccDataSorted = response.data.sort(
            (a, b) => new Date(b.test_date) - new Date(a.test_date)
          );

          let vaccDataFiltered = vaccDataSorted.filter(function (e) {
            return e.employee[1].trim() === data['display_name'].trim();
          });

          setCovidVaccinationData(vaccDataFiltered);
          setCompanyName(response && response.data[0].display_name);
          setCovidVaccinationChange(false);
        } else if (response.status === 201) {
          setCovidVaccinationChange(true);
          setErrVaccMsg('Access permission not allowed.');
        }
      });
  };
  function download(e, attachment) {
    axios
      .post(setting.serverUrl + '/api/downloadVaccineCertificate', {
        params: {
          email: localStorage.getItem('myData'),
          user: localStorage.getItem('myData'),
          pass: localStorage.getItem('myPass'),
          attachment_detail: attachment
        }
      })
      .then((response) => {
        setChange(!change);
        if (Array.isArray(response.data)) {
          setIsModalVisible(true);
          setImageUrls(response.data);
        } else {
          window.open(response.data);
        }
      });
  }
  function downloadAttachment(e, url) {
    axios
      .post(setting.serverUrl + '/api/downloadEmployeeAttachments', {
        params: {
          email: localStorage.getItem('myData'),
          user: localStorage.getItem('myData'),
          pass: localStorage.getItem('myPass'),
          attachment_detail: url
        }
      })
      .then((response) => {
        setChange(!change);
        setIsModalVisible(true);
        setImageUrl(response.data);
      });
  }

  return (
    <div style={{padding: '0 20px 20px 20px' }}>
      {data && (
        <>
          <div  className='d-flex justify-content-between align-items-center'>
          <h4 style={{ textAlign: 'left' }}>{empName ? empName + ' - Employee Details' : ''}</h4>
           <Button
              size='small'
              style={{
                backgroundColor: 'rgb(61 88 106)',
                color: 'white',
                marginTop: 0,
                padding: 10
              }}
              onClick={() => history.push({ pathname: `/vertical/employeeList` })}
            >
              Back
            </Button>
            </div>
          <div>
            <EmployeeDetail patient={data} />
          </div>

          <br />
          <TestDetailOfEmployee />
          {/* <Tabs defaultActiveKey='1' type='card'>
            <TabPane
              tab={
                <span style={{ fontSize: 16, textShadow: '1px 1px 3px #c0d7c0' }}>
                  Test Results
                </span>
              }
              key='1'
              style={{ fontSize: 6 }}
            >
              <TestDetailOfEmployee />
            </TabPane>
            {navTabCheck &&
              navTabCheck.length > 0 &&
              navTabCheck[0].covid_reports &&
              navTabCheck[0].covid_reports != null &&
              navTabCheck[0].covid_reports != false && (
                <TabPane
                  tab={
                    <span style={{ fontSize: 16, textShadow: '1px 1px 3px #c0d7c0' }}>
                      Covid Reports
                    </span>
                  }
                  key='9'
                  style={{ fontSize: 6 }}
                >
                  <div>
                    <div className='row'>
                      <div className='col-12 col-md-12 col-xl-12'>
                        <CovidReportOfEmployee empId={data['id']} />{' '}
                      </div>
                    </div>

                    <Modal
                      width={1000}
                      title='Covid Reports'
                      visible={isModalVisible}
                      onCancel={handleCancel}
                      footer={null}
                    >
                      {imageUrls &&
                        imageUrls.length > 0 &&
                        imageUrls.map((img) => {
                          console.log('img :: ', img);
                          return (
                            <p>
                              {img.fileType && img.fileType == 'application/pdf' ? (
                                <embed src={img.url} width='800px' height='2100px' />
                              ) : (
                                <img src={img.url} />
                              )}
                            </p>
                          );
                        })}
                    </Modal>
                  </div>
                </TabPane>
              )}
            {navTabCheck &&
              navTabCheck.length > 0 &&
              navTabCheck[0].covid_test &&
              navTabCheck[0].covid_test != null &&
              navTabCheck[0].covid_test != false && (
                <TabPane
                  tab={
                    <span style={{ fontSize: 16, textShadow: '1px 1px 3px #c0d7c0' }}>
                      Covid Testing
                    </span>
                  }
                  key='2'
                  style={{ fontSize: 6 }}
                >
                  <div>
                    <div className='row'>
                      <div className='col-12 col-md-12 col-xl-12'>
                        {hasCovTestPermission ? (
                          !covidTestChange ? (
                            <div>
                              {CovidTestData.length > 0 ? (
                                <>
                                  <CovidTestOfEmployee
                                    data={CovidTestData}
                                    docTestPermission={docTestPermission}
                                    download2={download2}
                                  />
                                </>
                              ) : (
                                <p
                                  style={{
                                    fontSize: 18,
                                    fontWeight: 700,
                                    padding: 20,
                                    color: '#ef6727'
                                  }}
                                >
                                  No Record Found!
                                </p>
                              )}
                            </div>
                          ) : (
                            <Row>
                              <Col span={10}></Col>
                              <Col span={8}>
                                <Space size='middle' style={{ marginTop: 10,marginLeft:85 }}>
                                  <Spin size='large' />
                                </Space>
                              </Col>
                            </Row>
                          )
                        ) : (
                          <div>
                            {isCovTestLoading && (
                              <Row>
                                <Col span={10}></Col>
                                <Col span={8}>
                                  <Space size='middle' style={{ marginTop: 50,marginLeft:85 }}>
                                    <Spin size='large' />
                                  </Space>
                                </Col>
                              </Row>
                            )}
                            <p style={{ fontSize: 18, fontWeight: 700, padding: 20, color: 'red' }}>
                              {covTestErrMsg}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>

                    <Modal
                      width={1000}
                      title='Covid Tests'
                      visible={isModalVisible}
                      onCancel={handleCancel}
                      footer={null}
                    >
                      {imageUrls &&
                        imageUrls.length > 0 &&
                        imageUrls.map((img) => {
                          console.log('img :: ', img);
                          return (
                            <p>
                              {img.fileType && img.fileType == 'application/pdf' ? (
                                <embed src={img.url} width='800px' height='2100px' />
                              ) : (
                                <img src={img.url} />
                              )}
                            </p>
                          );
                        })}
                    </Modal>
                  </div>
                </TabPane>
              )}
            {navTabCheck &&
              navTabCheck.length > 0 &&
              navTabCheck[0].covid_vac &&
              navTabCheck[0].covid_vac != null &&
              navTabCheck[0].covid_vac != false && (
                <TabPane
                  tab={
                    <span style={{ fontSize: 16, textShadow: '1px 1px 3px #c0d7c0' }}>
                      Covid Vaccinations
                    </span>
                  }
                  key='3'
                  style={{ fontSize: 6 }}
                >
                  <div>
                    <Card>
                      <div className='row'>
                        <div className='col-12 col-md-12 col-xl-12'>
                          <CovidVaccinationOfEmployee empId={data['id']} />
                        </div>
                      </div>
                    </Card>
                  </div>
                </TabPane>
              )}
            <TabPane
              tab={
                <span style={{ fontSize: 16, textShadow: '1px 1px 3px #c0d7c0' }}>
                  Attachments Detail
                </span>
              }
              key='4'
              style={{ fontSize: 6 }}
            >
              <div>
                {!attachmentChange ? (
                  <div>
                    {attachmentData.length > 0 ? (
                      <>
                        <AttachmentsDetail
                          data={attachmentData}
                          downloadAttachment={downloadAttachment}
                          hasAttachmentPermission={hasAttachmentPermission}
                        />
                      </>
                    ) : (
                      <p style={{ fontSize: 18, fontWeight: 700, padding: 20, color: '#ef6727' }}>
                        No Record Found!
                      </p>
                    )}
                  </div>
                ) : (
                  <Row>
                    <Col span={10}></Col>
                    <Col span={8}>
                      <Space size='middle' style={{ marginTop: 10, marginLeft:85 }}>
                        <Spin size='large' />
                      </Space>
                    </Col>
                  </Row>
                )}
                <Modal
                  width={1000}
                  title='Attachments'
                  visible={isModalVisible}
                  onCancel={handleCancel}
                  footer={null}
                >
                  <p>{<embed src={imageUrl} width='800px' height='2100px' />}</p>
                </Modal>
              </div>
            </TabPane>
          </Tabs> */}
        </>
      )}
    </div>
  );
};

export default PatientProfilePage;
